import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendarCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCalendarCheck"><Path d="M9 2H7V4H3V21H12V19H5V10H19V13H21V4H17V2H15V4H9V2Z" fill="currentColor"/><Path d="M22.4057 15.8438L20.844 14.5944L16.9172 19.5029L15.0002 17.5858L13.5859 19L17.0831 22.4971L22.4057 15.8438Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendarCheck;
